<template>
  <MainLayout>
    <div class="newActivityLunch">
      <div class="activityContainer">
        <div class="contact">
          <p>{{$t('global.咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。')}}</p>
          <a
            target="_blank"
            href="http://manaconsulting.mikecrm.com/TB45lq2"
          >{{$t('global.提交商务合作需求')}}>></a>
        </div>
      </div>
      <el-form ref="form" :rules="rules" :model="form" :label-position="labelPosition" id="view1">
        <div class="activityContainer">
          <h4 class="title">{{$t('global.基本信息')}}</h4>
          <el-form-item prop="title" :label="$t('global.活动标题')">
            <el-input type="text" :placeholder="$t('global.请输入活动标题')" v-model="form.title"></el-input>
            <span class="titleLen">{{titleLen}}/40</span>
          </el-form-item>
          <el-form-item :label="$t('global.举办时间')" required>
            <el-col :span="10">
              <el-form-item prop="holdDate">
                <el-date-picker
                  v-model="form.holdDate"
                  type="daterange"
                  :range-separator="$t('global.至')"
                  :start-placeholder="$t('global.开始日期')"
                  :end-placeholder="$t('global.结束日期')"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('global.报名时间')" required>
            <el-col :span="10">
              <el-form-item prop="signDate">
                <el-date-picker
                  v-model="form.signDate"
                  type="daterange"
                  :range-separator="$t('global.至')"
                  :start-placeholder="$t('global.开始日期')"
                  :end-placeholder="$t('global.结束日期')"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('global.举办地点')" required>
            <el-col :span="6">
              <el-select
                  v-model="country"
                  filterable
                  @change="resetArea"
                  :placeholder="$t('project.请搜索或选择国家')"
                >
                <el-option
                  :label="language === 'zh' ? item.zh : item.en"
                  :value="item.id"
                  v-for="item in countryOptions"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="city">
                <el-select
                  v-model="form.city"
                  filterable
                  :placeholder="$t('global.请选择城市')"
                >
                  <el-option
                    :label="language === 'zh' ? item.zh : item.en"
                    :value="item.id"
                    v-for="item in cityOptions"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="place">
                <el-input v-model="form.place" :placeholder="$t('global.输入地址')"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item prop="cover" :label="$t('global.活动封面')" id="view2">
            <div class="upload uploadCover" @click="upImgClick()">
              <div class="add-wrap">
                <img v-if="!form.cover" src="/static/uploadvideo/staticicon.png" alt class="add" />
                <img v-else :src="form.cover | imageUrl('',360,480)" class="thumb" />
                <div class="font">
                  <span v-if="!form.cover">{{$t('global.上传封面')}}</span>
                  <span v-else>{{$t('global.修改')}}</span>
                </div>
              </div>
            </div>
            <span class="limit">{{$t('global.格式jpeg、png，文件大小≤3MB，图片比例3:4，尺寸≥360*480')}}</span>
          </el-form-item>
          <el-form-item prop="activityTypeIds" :label="$t('global.活动类型')">
            <el-checkbox-group :max="3" v-model="form.activityTypeIds" size="medium">
              <el-checkbox-button
                v-for="item in activityTypeList"
                :label="item.id"
                :key="item.id"
              >{{item.typeName}}</el-checkbox-button>
            </el-checkbox-group>
            <span class="limit">{{$t('global.最多选择3个')}}</span>
          </el-form-item>
          <el-form-item prop="tags" :label="$t('global.标签')">
            <el-checkbox-group v-model="form.tags" :max="3">
              <el-checkbox-button
                v-for="item in tagList"
                :label="item.title"
                :key="item.title"
              >{{item.title}}</el-checkbox-button>
              <a class="clickaddtitle" @click="addEquipment = true">{{$t('global.新增')}}</a>
            </el-checkbox-group>
            <template v-if="addEquipment">
              <div class="userinfortit">
                <input type="text" v-model="newTag" maxlength="30" :placeholder="$t('global.输入标签')" />
                <a @click="saveNewTag()">{{$t('global.确定')}}</a>
              </div>
            </template>
            <span class="limit">{{$t('global.选填')}}，{{$t('global.最多选择3个')}}</span>
          </el-form-item>
          <el-form-item :label="$t('global.参与人员')">
            <div class v-for="(item,index) in form.joinPersonsJson" :key="index">
              <img :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)" class="fanHead" />
              <span class="nickname">{{item.nickname}}</span>
              <el-input
                class="role"
                :maxlength="item.max"
                v-model="item.role"
                :placeholder="`${$t('global.在活动中的角色')}，${$t('global.选填')}`"
              ></el-input>
              <span class="roleLen">{{getLen(item,index)}}/8</span>
              <span @click="deleteCreater(index)" class="deleteOC">{{$t('global.删除')}}</span>
            </div>
            <el-select
              v-model="chooseJoin.nickname"
              filterable
              remote
              :remote-method="searchUser"
              :placeholder="$t('global.请选择')"
              class="elselect"
            >
              <el-option v-for="(item,index) in fanlist" :key="index" :value="deteleHtml(item.nickname)">
                <div @click="chooseJoin=item">
                  <img :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)" class="fanHead" />
                  <i v-html="item.nickname"></i>
                </div>
              </el-option>
            </el-select>
            <el-button type="primary" @click="addCreater()">{{$t('global.确定')}}</el-button>
            <span class="limit block">{{$t('global.选填，可以填写艺术家、策展人、主办方等参与人员')}}</span>
          </el-form-item>
          <el-form-item :label="$t('global.参与方式')" required id="view3">
            <el-radio-group v-model="form.joinType" size="medium">
              <el-radio-button
                v-for="item in joinTypeList"
                :label="item.id"
                :key="item.id"
              >{{item.text}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('global.门票价格')" required v-if="form.joinType === 1">
            <el-form-item prop="price">
              <el-input v-model="form.price" :placeholder="$t('global.例如')+`：￥20~￥100，￥200`"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item
            :label="$t('global.报名/购票链接')"
            required
            v-if="form.joinType !== 2 && form.joinType !== 3"
          >
            <el-form-item prop="tickLink">
              <el-input v-model="form.tickLink" placeholder></el-input>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="activityContainer" v-if="form.joinType===2">
          <h4 class="title">{{$t('global.票种信息')}}</h4>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="ticketName" :label="$t('global.票种名称')" width="150"></el-table-column>
            <el-table-column prop="ticketPrice" :label="$t('global.价格')" width="80">
              <template slot-scope="scope">
                <p>{{tableData[scope.$index].price||$t('global.免费')}}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('global.数量')" width="120">
              <template slot-scope="scope">
                <p>{{tableData[scope.$index].ticketSellAmount}}/{{tableData[scope.$index].ticketAmount}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="ticketMaxAmount" :label="$t('global.最大购买数量')" width="110"></el-table-column>
            <el-table-column prop="ticketStartTime" :label="$t('global.售卖开始时间')"></el-table-column>
            <el-table-column prop="ticketEndTime" :label="$t('global.售卖截止时间')"></el-table-column>
            <el-table-column prop="status" :label="$t('global.售卖状态')" width="100">
              <template slot-scope="scope">
                <p>
                  {{
                  tableData[scope.$index].id
                  ?
                  tableData[scope.$index].status === 2?
                  new Date(tableData[scope.$index].ticketStartTime).getTime() < Date.now() &&
                  new Date(tableData[scope.$index].ticketEndTime).getTime() > Date.now()
                  /**在售卖时间范围内 */
                  ? tableData[scope.$index].ticketAmount === tableData[scope.$index].ticketSellAmount?$t("global.已售罄"):$t("global.售卖中")
                  : new Date(tableData[scope.$index].ticketStartTime).getTime() > Date.now()
                  /**还未开始售卖 */
                  ? $t("global.尚未开始")
                  : $t("global.已结束")
                  : $t("global.暂停售卖")
                  : $t("global.新建")
                  }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="handle" :label="$t('global.操作')" width="100">
              <template slot-scope="scope">
                <a href="javascript:;" @click="openTicket(scope.$index)">{{$t('global.编辑')}}</a>
                <a
                  href="javascript:;"
                  @click="deleteRow(scope.$index)"
                  v-if="!tableData[scope.$index].id"
                >{{$t('global.删除')}}</a>
                <a
                  href="javascript:;"
                  @click="changeRowStatus(scope.$index)"
                  v-if="tableData[scope.$index].id"
                >{{tableData[scope.$index].status === 2 ?$t('global.下架'):$t('global.上架')}}</a>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" class="primary" @click="openTicket()">+ {{$t('global.添加免费票')}}</el-button>
        </div>
        <div class="activityContainer">
          <h4 class="title">{{$t('global.活动图片')}}</h4>
          <el-form-item :required="false" :label="$t('global.活动图片')">
            <span class="limit">{{$t('global.选填，图片不超过3M')}}</span>
            <div class="bline"></div>
            <el-upload
              class="thumb-uploader"
              ref="uploadimgs"
              action="/api/common/upload/image"
              name="files"
              multiple
              accept="image/*"
              list-type="picture-card"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :before-upload="beforeThumbUpload"
              :on-success="handleThumbSuccess"
              :file-list="back_fileList"
            >
              <i class="thumb-uploader-icon">{{$t('global.请上传活动图片')}}</i>
            </el-upload>
          </el-form-item>
        </div>
        <div class="activityContainer" id="view4">
          <h4 class="title">{{$t('global.活动详情')}}</h4>
          <div class="tinymce">
            <span class="font required">{{$t('global.活动详情')}}</span>
            <tinymc-editor :content="tinymceHtml" @changeEdit="changeEdit" />
          </div>
        </div>
        <div class="button-wrap">
          <el-button
            class="confirm keep button"
            @click="keepDraft"
            v-if="!activityId"
          >{{$t('global.保存草稿')}}</el-button>
          <el-button class="confirm button" @click="submit">{{$t('global.提交')}}</el-button>
        </div>
      </el-form>
      <cropImg
        ref="cropComponent"
        :dialog-width="900"
        :dialog-height="590"
        :crop-width="360"
        :crop-height="480"
        :min-width="360"
        :min-height="480"
        :fixed="fixed"
        :fixedBox="fixedBox"
        :fixedNumber="fixedNumber"
        :original="original"
        @update-img="updateImage"
        :is-upload="isUpload"
      ></cropImg>
      <el-dialog
        class="ticket-dialog"
        :title="$t('global.编辑门票')"
        :lock-scroll="false"
        :visible.sync="showTicketEdit"
        width="30%"
        :before-close="()=>{showTicketEdit = false}"
      >
        <div class="body">
          <el-form ref="form1" :rules="ticketRules" :model="ticketData" label-width="140px">
            <el-form-item prop="ticketName" :label="$t('global.票种名称')">
              <el-input v-model="ticketData.ticketName" maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item prop="ticketAmount" :label="$t('global.数量')">
              <el-input
                class="number"
                type="number"
                :min="0"
                v-model.number="ticketData.ticketAmount"
                @blur="checkAmount('ticketAmount')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="ticketMaxAmount" :label="$t('global.最大购买数量')">
              <el-input
                class="number"
                type="number"
                :min="0"
                v-model.number="ticketData.ticketMaxAmount"
                @blur="checkAmount('ticketMaxAmount')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="ticketStartTime" :label="$t('global.售卖开始时间')">
              <el-date-picker
                class="number"
                v-model="ticketData.ticketStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                :picker-options="startDateDisabled"
                @change="changeTicketStartTime"
                :placeholder="$t('global.开始时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="ticketEndTime" :label="$t('global.售卖结束时间')">
              <el-date-picker
                class="number"
                v-model="ticketData.ticketEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                :picker-options="endDateDisabled"
                @change="checkTicketEndTime"
                :placeholder="$t('global.结束时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('global.补充说明')" prop="ticketTranmemo">
              <el-input
                type="textarea"
                maxlength="100"
                show-word-limit
                v-model="ticketData.ticketTranmemo"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showTicketEdit = false">{{$t('global.取 消')}}</el-button>
          <el-button type="primary" @click="saveTicket">{{$t('global.确 定')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import CheckboxGroup from "@/components/widgets/CheckboxGroup";
import tinymcEditor from "@/components/editor/Editor";
import { formatDate, imageUrl, unImageUrl } from "@/util/filters.js";
import cropImg from "@/components/CropImg.vue";

export default {
  name: "ActivityLunch",
  metaInfo() {
    return {
      title: this.$t("global.线下活动") + " | MANA"
    };
  },
  components: {
    CheckboxGroup,
    MainLayout,
    tinymcEditor,
    cropImg
  },
  model: {
    prop: "toggleForm",
    event: "toggleForm"
  },
  props: {
    toggleForm: Boolean
  },
  data() {
    var checkHold = (rule, value, callback) => {
      callback();
    };
    var checkSign = (rule, value, callback) => {
      callback();
    };
    return {
      countryOptions: [],
      country: "",
      cityOptions: [],
      fixed: true,
      fixedNumber: [3, 4],
      fixedBox: false,
      original: false,
      startDateDisabled: {},
      endDateDisabled: {},
      tableData: [],
      ticketData: {},
      updateIds: [],
      showTicketEdit: false,
      props: {
        value: "id",
        label: this.$language() === "zh" ? "zh" : "en",
        children: "city"
      },
      chooseJoin: {},
      addEquipment: false,
      fanlist: [],
      tagList: [],
      activityTypeList: [],
      joinTypeList: [
        { id: 2, text: this.$t("global.MANA平台报名") },
        { id: 1, text: this.$t("global.其他平台售票") },
        { id: 0, text: this.$t("global.其他平台免费报名") },
        { id: 3, text: this.$t("global.无需报名") }
      ],
      config: {
        initialFrameHeight: 350
      },
      provinceObj: {},
      defaultMsg: "",
      labelPosition: "top",
      isUpload: false,
      titleLen: 0,
      form: {
        price: "",
        joinType: 2,
        activityTypeIds: [],
        title: "",
        signDate: [],
        holdDate: [],
        cover: "",
        thumb: [],
        content: "",
        place: "",
        city: "",
        cityList: [],
        tickLink: "",
        tags: [],
        joinPersonsJson: []
      },
      imgList: [],
      scale: [],
      imgUrl: "",
      isHidden: true,
      ticketRules: {
        ticketName: [
          {
            required: true,
            message: this.$t("global.请填写活动名称"),
            trigger: "blur"
          }
        ],
        ticketAmount: [
          {
            required: true,
            message: this.$t("global.请填写数量"),
            trigger: "blur"
          }
        ],
        ticketMaxAmount: [
          {
            required: true,
            message: this.$t("global.请填写最大购买数量"),
            trigger: "blur"
          }
        ],
        ticketStartTime: [
          {
            required: true,
            message: this.$t("global.请填写售卖开始时间"),
            trigger: "blur"
          }
        ],
        ticketEndTime: [
          {
            required: true,
            message: this.$t("global.请填写售卖结束时间"),
            trigger: "blur"
          }
        ]
      },
      rules: {
        signDate: [
          {
            required: true,
            message: this.$t("global.请选择报名时间"),
            trigger: "blur"
          },
          { validator: checkSign, trigger: "change" }
        ],
        holdDate: [
          {
            required: true,
            message: this.$t("global.请选择举办时间"),
            trigger: "blur"
          },
          { validator: checkHold, trigger: "change" }
        ],
        cover: [
          {
            required: true,
            message: this.$t("global.请上传图片封面"),
            trigger: "change"
          }
        ],
        title: [
          {
            required: true,
            message: this.$t("global.活动标题不能为空"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              const reg1 = /[^\x00-\xff]/g;
              let len = value.length;
              if (reg1.test(value)) {
                len += value.match(reg1) && value.match(reg1).length;
              }
              if (len > 80) {
                callback(
                  new Error(this.$t("global.活动标题不能超过40个中文字符!"))
                );
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        activityTypeIds: [
          {
            required: true,
            message: this.$t("global.请选择活动类型"),
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (!value.length) {
                lcallback(new Error(this.$t("global.请选择活动类型")));
                return;
              }
              callback();
            },
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: this.$t("global.请选择城市"),
            trigger: "blur"
          }
        ],
        place: [
          {
            required: true,
            message: this.$t("global.请输入地址"),
            trigger: "blur"
          }
        ],
        tickLink: [
          {
            required: true,
            message: this.$t("global.请输入报名") / this.$t("global.购票链接"),
            trigger: "blur"
          }
        ]
      },
      activityId: null,
      backFileData: "",
      back_fileList: [],
      tinymceHtml: "",
      options: [
        {
          en: this.$t("global.国内"),
          zh: "国内",
          id: 10001,
          city: []
        },
        {
          en: this.$t("global.国际"),
          zh: "国际",
          id: 10002,
          city: []
        }
      ]
    };
  },
  computed: {
    language() {
      return this.$language();
    },
    localTime() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    }
  },
  watch: {
    country(value) {
      if (value || value === 0) {
        this.getCity(value);
      }
    },
    "form.title"(val) {
      const reg1 = /[^\x00-\xff]/g;
      let len = val.length;
      if (reg1.test(val)) {
        len += val.match(reg1) && val.match(reg1).length;
      }
      this.titleLen = Math.ceil(len / 2);
    },
    // "form.cityList"(val) {
    //   if (val) {
    //     this.form.city = val[val.length - 1];
    //   }
    // },
    titleLen(val) {
      if (val > 40) {
        const len = this.form.title.length;
        this.form.title = this.form.title.substring(0, len - 1);
      }
    }
  },
  created() {
    this.init();
    const timeRange = [
      "00:00:00 - 00:00:00",
      "00:30:00 - 00:30:00",
      "01:00:00 - 01:00:00",
      "01:30:00 - 01:30:00",
      "02:00:00 - 02:00:00",
      "02:30:00 - 02:30:00",
      "03:00:00 - 03:00:00",
      "03:30:00 - 03:30:00",
      "04:00:00 - 04:00:00",
      "04:30:00 - 04:30:00",
      "05:00:00 - 05:00:00",
      "05:30:00 - 05:30:00",
      "06:00:00 - 06:00:00",
      "06:30:00 - 06:30:00",
      "07:00:00 - 07:00:00",
      "07:30:00 - 07:30:00",
      "08:00:00 - 08:00:00",
      "08:30:00 - 08:30:00",
      "09:00:00 - 09:00:00",
      "09:30:00 - 09:30:00",
      "10:00:00 - 10:00:00",
      "10:30:00 - 10:30:00",
      "11:00:00 - 11:00:00",
      "11:30:00 - 11:30:00",
      "12:00:00 - 12:00:00",
      "12:30:00 - 12:30:00",
      "13:00:00 - 13:00:00",
      "13:30:00 - 13:30:00",
      "14:00:00 - 14:00:00",
      "14:30:00 - 14:30:00",
      "15:00:00 - 15:00:00",
      "15:30:00 - 15:30:00",
      "16:00:00 - 16:00:00",
      "17:00:00 - 17:00:00",
      "16:30:00 - 16:30:00",
      "17:30:00 - 17:30:00",
      "18:00:00 - 18:00:00",
      "18:30:00 - 18:30:00",
      "19:00:00 - 19:00:00",
      "19:30:00 - 19:30:00",
      "20:00:00 - 20:00:00",
      "20:30:00 - 20:30:00",
      "21:00:00 - 21:00:00",
      "21:30:00 - 21:30:00",
      "22:00:00 - 22:00:00",
      "22:30:00 - 22:30:00",
      "23:00:00 - 23:00:00",
      "23:30:00 - 23:30:00"
    ];
    this.startDateDisabled.disabledDate = this.disabledStartDate;
    this.endDateDisabled.disabledDate = this.disabledEndDate;
    this.startDateDisabled.selectableRange = timeRange;
    this.endDateDisabled.selectableRange = timeRange;
    this.startDateDisabled.format = "HH:mm";
    this.endDateDisabled.format = "HH:mm";
  },
  methods: {
    init() {
      this.getActivityTypeList();
      this.getArea();
      this.getCountry();
      if (this.$route.query.activityId) {
        this.activityId = this.$route.query.activityId;
        document.title = `${this.$t("global.编辑活动")} | MANA`;
        this.$http
          .get("/api/activity/detail", {
            params: {
              activityId: this.activityId
            }
          })
          .then(data => {
            this.backFile_fn(data.data);
            this.getTagList();
          });
      } else {
        if (localStorage.hasOwnProperty("activity")) {
          const obj = JSON.parse(localStorage.getItem("activity"));
          this.form = obj.form;
          this.tinymceHtml = obj.tinymceHtml;
          this.back_fileList = obj.back_fileList;
          this.tableData = obj.ticketInformation;
        }
        this.getTagList();
      }
    },
    deteleHtml(html) {
      let reg = /(<\/?em.*?>)/gi;
      return html.replace(reg, "");
    },
    checkAmount(field) {
      if (field === "ticketAmount") {
        if (
          this.ticketData.ticketAmount < this.ticketData.ticketMaxAmount ||
          this.ticketData.ticketAmount < this.ticketData.ticketSellAmount
        ) {
          if (
            this.ticketData.ticketMaxAmount < this.ticketData.ticketSellAmount
          ) {
            this.ticketData.ticketAmount = this.ticketData.ticketSellAmount;
          } else {
            this.ticketData.ticketAmount = this.ticketData.ticketMaxAmount;
          }
          this.$message(
            this.$t("global.票数不可小于最大购买数量,且不可小于已售数量")
          );
        }
      } else if (field === "ticketMaxAmount") {
        if (
          this.ticketData.ticketMaxAmount > this.ticketData.ticketAmount ||
          this.ticketData.ticketMaxAmount <= 0
        ) {
          this.ticketData.ticketMaxAmount = this.ticketData.ticketAmount;
          this.$message(
            this.$t("global.最大购买数量不可小于0,且不可大于总票数")
          );
        }
      }
    },
    changeTicketStartTime(val) {
      this.endDateDisabled.disabledDate = this.disabledEndDate2;
      if (
        this.ticketData.ticketEndTime &&
        val >= new Date(this.ticketData.ticketEndTime).getTime()
      ) {
        this.ticketData.ticketEndTime = "";
        this.$message.error(this.$t("global.开始时间不能大于结束时间"));
      }
    },
    checkTicketEndTime(val) {
      if (
        this.ticketData.ticketStartTime &&
        new Date(this.ticketData.ticketStartTime).getTime() >= val
      ) {
        this.ticketData.ticketEndTime = "";
        this.$message.error(this.$t("global.开始时间不能大于结束时间"));
      }
    },
    deleteRow(index) {
      this.$confirm(
        this.$t("global.确定删除这个票种?"),
        this.$t("global.提示"),
        {
          customClass: "activity-message",
          confirmButtonText: this.$t("global.确定"),
          lockScroll: false,
          cancelButtonText: this.$t("global.取消"),
          type: "warning"
        }
      )
        .then(() => {
          this.tableData.splice(index, 1);
          this.$message({
            type: "success",
            message: this.$t("global.删除成功")
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("global.已取消删除")
          });
        });
    },
    disabledStartDate(time) {
      return time <= Date.now() - 3600 * 24 * 1000;
    },
    disabledEndDate(time) {
      return time <= Date.now() - 3600 * 24 * 1000;
    },
    disabledEndDate2(time) {
      return (
        time <=
        new Date(this.ticketData.ticketStartTime).getTime() - 3600 * 24 * 1000
      );
    },
    changeRowStatus(index) {
      const text =
        this.tableData[index].status === 2
          ? this.$t(`global.下架`)
          : this.$t(`global.上架`);
      this.$confirm(
        `${this.$t(`global.确定要将这个票种`)}+${text}?`,
        this.$t(`global.提示`),
        {
          customClass: "activity-message",
          confirmButtonText: this.$t(`global.确定`),
          lockScroll: false,
          cancelButtonText: this.$t(`global.取消`),
          type: "warning"
        }
      )
        .then(() => {
          this.updateIds.push(this.tableData[index].id);
          this.updateIds = [...this.updateIds];
          this.tableData[index].status =
            this.tableData[index].status === 2 ? -1 : 2;
          this.$message({
            type: "success",
            message: `${text}${$t("global.成功")}!`
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${$t("global.已取消")}${text}`
          });
        });
    },
    saveTicket() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          if (this.ticketData.id) {
            this.updateIds.push(this.ticketData.id);
            this.updateIds = [...this.updateIds];
          }
          const ticketData = {
            ...this.ticketData,
            ticketStartTime: formatDate(
              this.ticketData.ticketStartTime,
              "YYYY-MM-DD HH:mm"
            ),
            ticketEndTime: formatDate(
              this.ticketData.ticketEndTime,
              "YYYY-MM-DD HH:mm"
            ),
            ticketSellAmount:
              this.chooseIndex || this.chooseIndex === 0
                ? this.tableData[this.chooseIndex].ticketSellAmount
                : 0,
            status: this.ticketData.status || 2
          };
          if (this.chooseIndex || this.chooseIndex === 0) {
            this.tableData.splice(this.chooseIndex, 1, ticketData);
          } else {
            this.tableData.push(ticketData);
          }
          this.showTicketEdit = false;
          this.chooseIndex = null;
        }
      });
    },
    openTicket(index) {
      if (typeof index !== "undefined") {
        this.chooseIndex = index;
        this.ticketData = { ...this.tableData[index] };
      } else {
        this.ticketData = {};
      }
      this.showTicketEdit = true;
    },
    filterMethod(node, key) {
      return (
        node.data.name.includes(key) ||
        node.data.abb.includes(key) ||
        node.data.spell.includes(key)
      );
    },
    getTagList() {
      const url = `/api/other/tagListOrTag`;
      const params = {
        type: 6
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.tagList = [...this.tagList, ...res.data];
          this.form.tags.forEach(item => {
            const flag = this.tagList.find(it => it.title === item);
            if (!flag) {
              this.tagList = [...this.tagList, { id: item, title: item }];
            }
          });
        }
      });
    },
    getActivityTypeList() {
      const url = `/api/activity/activityTypeList`;
      this.$http.get(url).then(res => {
        if (res.code === "OK") {
          this.activityTypeList = res.data.length ? res.data : [];
        }
      });
    },
    getLen(item, index) {
      const reg = /[^\x00-\xff]/g;
      let len = item.role.length;
      if (reg.test(item.role)) {
        len += item.role.match(reg) && item.role.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 8) {
        item.max = len;
      }
      return roleLen;
    },
    addCreater() {
      if (this.chooseJoin.nickname) {
        this.form.joinPersonsJson.push(this.chooseJoin);
        this.chooseJoin = {};
      }
    },
    editCreater() {},
    deleteCreater(index) {
      this.form.joinPersonsJson.splice(index, 1);
    },
    searchUser(query) {
      if (query) {
        this.$http
          .post(
            "/api/search/list2",
            {
              keyword: query,
              type: 2,
              pageIndex: 1,
              pageSize: 50
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.data && res.data.pageList && res.data.pageList.list) {
              this.fanlist = filter_user(res.data.pageList.list);
            }
          });
      }
      function filter_user(list) {
        let userList = [];
        for (let i = 0; i < list.length; i++) {
          const el = list[i];
          const userDetail = {
            avatar: el.avatar,
            creatorId: el.userId,
            nickname: el.nickname,
            role: ""
          };
          userList.push(userDetail);
        }
        return userList;
      }
    },
    saveNewTag() {
      if (this.newTag && this.newTag.trim()) {
        this.tagList.push({ id: this.newTag, title: this.newTag });
        this.form.tags.push(this.newTag);
        this.newTag = "";
        this.addEquipment = false;
      }
    },
    upImgClick(index) {
      this.$refs.cropComponent.reUpload("3size");
    },
    updateImage(img) {
      // this.form.cover = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(img.data, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }

      let param = new FormData();
      param.append("files", imgFile);
      param.append("fileNames", "cover");

      this.$http
        .post("/api/common/upload/image", param, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.code === "OK") {
            this.form.cover = response.data;
            this.$message({
              message: response.message,
              type: "success"
            });
            // this.handleCoverSuccess();
          }
        });
    },
    changeEdit(content) {
      this.tinymceHtml = content;
    },
    backFile_fn(data) {
      const _this = this;
      //$t('global.活动标题')
      this.form.title = data.title;
      //$t('global.活动类型')
      this.form.activityTypeIds = data.activityTypeIds.split(",");
      //$t('global.价格')
      this.form.price = data.price;
      this.form.city = data.city;
      // this.form.cityList =
      //   data.cityList && data.cityList.split(",").map(item => +item);
      this.form.place = data.place;
      this.form.tags = (data.tags && JSON.parse(data.tags)) || [];
      this.form.joinType = data.joinType;
      this.form.joinPersonsJson =
        (data.joinPersonsJson && JSON.parse(data.joinPersonsJson)) || [];
      //活动举办时间
      this.form.holdDate = [
        formatDate(data.holdStartTime).split(" ")[0],
        formatDate(data.holdEndTime).split(" ")[0]
      ];
      this.form.signDate = [
        formatDate(data.signStartTime).split(" ")[0],
        formatDate(data.signEndTime).split(" ")[0]
      ];
      if (data.activityTicketDomainList) {
        this.tableData = data.activityTicketDomainList.map(item => ({
          ...item,
          ticketStartTime: formatDate(item.ticketStartTime, "YYYY-MM-DD HH:mm"),
          ticketEndTime: formatDate(item.ticketEndTime, "YYYY-MM-DD HH:mm")
        }));
      }
      if(this.cityOptions.length==0){
        this.cityOptions=[{
          "id": data.city,
          "zh": data.cityName,
          "en": data.cityName,
        }]
      }

      //活动封面
      this.form.cover = data.thumb;
      this.form.tickLink = data.purchaseLink;
      //$t('global.活动图片')
      for (let i = 0; i < data.imageList.length; i++) {
        const el = data.imageList[i];
        const Obj = {
          name: "img-" + i,
          url: imageUrl(el)
        };
        this.back_fileList.push(Obj);
        this.form.thumb.push(el);
      }
      //$t('global.活动介绍')
      this.tinymceHtml = data.introduction;
    },
    randomString() {
      var len = 2;
      var $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    handleRemove(file, fileList) {
      const thumb = [];
      const back_fileList = [];
      for (let i = 0; i < fileList.length; i++) {
        const el = fileList[i];
        thumb.push(unImageUrl(el.url));
        back_fileList.push({
          name: `img-${i}`,
          url: imageUrl(el.url)
        });
      }
      this.form.thumb = thumb;
      this.back_fileList = back_fileList;
    },
    handleExceed() {
      this.$message.error(this.$t("global.超出图片上传个数限制"));
    },
    beforeCoverUpload(file, fileList) {
      let isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return false;
      }
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    beforeThumbUpload(file) {
      let isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return false;
      }
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.imgUrl =
        "/api/common/upload/image?" +
        this.randomString() +
        "=" +
        this.randomString();
    },
    back_imgList(file) {
      console.log(file);
    },
    handleCoverSuccess(res, file) {
      if (this.loading) this.loading.close();
      this.form.cover = res.data;
      this.$message.success(this.$t("global.上传图片成功"));
    },
    handleThumbSuccess(res, file) {
      if (this.loading) {
        this.loading.close();
      }
      if (res.code === "OK") {
        this.form.thumb.push(res.data);
        this.back_fileList.push({
          name: `img-${this.back_fileList.length}`,
          url: imageUrl(res.data)
        });
      }
    },
    submit() {
      let postUrl = "";
      if (!this.form.title.replace(/[\r\n\s]/g, "")) {
        this.$message({
          message: this.$t("global.活动标题不能为空"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.holdDate.length) {
        this.$message({
          message: this.$t("global.请选择举办时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.signDate.length) {
        this.$message({
          message: this.$t("global.请选择报名时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (this.form.signDate[1] > this.form.holdDate[1]) {
        this.$message({
          message: this.$t("global.报名结束时间不可晚于举办结束时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.city) {
        this.$message({
          message: this.$t("global.请选择城市"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.place) {
        this.$message({
          message: this.$t("global.请输入地址"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.cover) {
        this.$message({
          message: this.$t("global.请上传图片封面"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.activityTypeIds.length) {
        this.$message({
          message: this.$t("global.请选择活动类型"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view2").scrollIntoView(true);
        return;
      }
      if (this.form.joinType === 1){
        if (!this.form.price) {
          this.$message({
            message: this.$t("works.请输入门票价格"),
            type: "error",
            duration: 2000
          });
          document.getElementById("view3").scrollIntoView(true);
          return;
        }
        if (!this.form.tickLink) {
          this.$message({
            message: this.$t("global.请输入报名/购票链接"),
            type: "error",
            duration: 2000
          });
          document.getElementById("view3").scrollIntoView(true);
          return;
        }
        const reg = /^http(s?):\/\//;
        if (this.form.tickLink && !reg.test(this.form.tickLink)) {
          this.$message({
              message: this.$t("works.链接应以http://或 https://开头"),
              type: "error",
              duration: 2000
            });
            document.getElementById("view3").scrollIntoView(true);
            return;
        }
      }
      if (this.form.joinType === 0) {
        if (!this.form.tickLink) {
          this.$message({
            message: this.$t("global.请输入报名/购票链接"),
            type: "error",
            duration: 2000
          });
          document.getElementById("view3").scrollIntoView(true);
          return;
        }
        const reg = /^http(s?):\/\//;
        if (this.form.tickLink && !reg.test(this.form.tickLink)) {
          this.$message({
              message: this.$t("works.链接应以http://或 https://开头"),
              type: "error",
              duration: 2000
            });
            document.getElementById("view3").scrollIntoView(true);
            return;
        }
      }
      if (!this.tinymceHtml) {
        this.$message({
          message: this.$t("global.请填写活动详情"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view4").scrollIntoView(true);
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          const tableData = this.tableData.map(item => {
            const {
              ticketSellAmount,
              activityId,
              ticketSurplusAmount,
              createTime,
              ...reset
            } = item;
            return reset;
          });
          const param = {
            ticketInformation: JSON.stringify(tableData),
            updateIds: this.updateIds.join(","),
            category: 2,
            images: this.form.thumb,
            title: this.form.title,
            thumb: this.form.cover,
            introduction: this.tinymceHtml,
            signStartTime: this.form.signDate[0],
            signEndTime: this.form.signDate[1],
            holdStartTime: this.form.holdDate[0],
            holdEndTime: this.form.holdDate[1],
            purchaseLink: this.form.tickLink,
            price: this.form.joinType === 1 ? this.form.price : undefined,
            city: this.form.city,
            place: this.form.place,
            tags: this.form.tags && JSON.stringify(this.form.tags),
            joinType: this.form.joinType,
            joinPersonsJson:
              this.form.joinPersonsJson &&
              JSON.stringify(this.form.joinPersonsJson),
            joinPersons:
              this.form.joinPersonsJson &&
              this.form.joinPersonsJson.map(item => item.creatorId),
            activityTypeIds: this.form.activityTypeIds.join(",")
          };
          if (this.activityId) {
            postUrl = "/api/u/activity/update";
            param.id = this.activityId;
          } else {
            postUrl = "/api/u/activity/apply";
          }
          this.$http.post(postUrl, param).then(response => {
            if (response.code === "OK") {
              localStorage.removeItem("activity");
              this.$message({
                message: this.$t("global.提交成功"),
                type: "success",
                duration: 2000
              });
              if (this.activityId) {
                this.$router.push(`/activity/${this.activityId}/detail`);
              } else {
                this.$router.push("/activity/all");
              }
            } else {
              this.$message({
                message: response.message,
                type: "error",
                duration: 2000
              });
            }
          });
        }
      });
    },
    keepDraft() {
      let key = `activity`;
      localStorage.setItem(
        key,
        JSON.stringify({
          form: this.form,
          tinymceHtml: this.tinymceHtml,
          back_fileList: this.back_fileList,
          ticketInformation: this.tableData
        })
      );
      this.$message({
        message: this.$t("global.保存草稿成功"),
        type: "success",
        duration: 2000
      });
    },getCountry() {
      this.$http.get("/api/mobile/area/getCountry").then((res) => {
        if (res.code === "OK") {
          const data = res.data;
          Object.keys(data).filter((item) => {
            this.countryOptions = [...this.countryOptions, ...data[item]];
          });
          if (this.language === "zh") {
            this.countryOptions.unshift({
              city: [],
              en: "China",
              id: 0,
              py: "CHN",
              pyf: "C",
              value: "",
              zh: "中国",
            });
          }
        }
      });
    },
    resetArea() {
      this.city = "";
    },
    getCity(id) {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=${id}`)
        .then((res) => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },getArea() {
      this.$http.get("/api/common/country/list").then((response) => {
        this.options = response.data;
        this.$store.dispatch("setArea", response.data);
      });
    },
  }
};
</script>
<style lang="stylus" scoped>
.roleLen {
  margin-left: -55px;
  z-index: 10;
  position: relative;
  padding-right: 30px;
}

.deleteOC {
  font-size: 14px;
  font-weight: 400;
  color: #446EEB;
  cursor: pointer;
}

.role {
  display: inline-block;
  width: 250px;
  margin: 0 20px;
}

.elselect {
  margin-top: 20px;
}

.fanHead {
  width: 0.32rem;
  height: 0.32rem;
  margin: -0.02rem 0.1rem 0 0;
}

.userinfortit {
  position: relative;
  float: left;
  width: 150px;
  height: 32px;
  margin-top: 12px;
}

.userinfortit input[type='text'] {
  float: left;
  width: 100px !important;
  height: 32px !important;
  font-size: 14px;
  padding-left: 10px;
  background-color: #f3f3f3;
  border-radius: 16px 0 0 16px !important;
  box-sizing: border-box;
}

.userinfortit a {
  float: left;
  width: 50px;
  height: 32px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  border-radius: 0 16px 16px 0;
  background-color: #4a90e2;
}

.clickaddtitle {
  display: inline-block;
  width: 65px;
  height: 28px;
  cursor: pointer;
  text-align: center;
  color: #999;
  margin-bottom: 10px;
  border-radius: 16px;
  line-height: 28px;
  font-size: 14px;
  border: 1px solid #ccd0d7;
  background: #f3f3f3;
}

h4.title {
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #000;
  line-height: 28px;
  margin-bottom: 30px;
}

.uploadCover {
  display: inline-block;
  height: 240px;
  width: 180px;
  background: #f4f5f7;
  cursor: pointer;
  border-radius: 10px;

  .add-wrap {
    position: relative;
    height: 240px;
    width: 180px;
    line-height: 240px;
    text-align: center;
    overflow: hidden;

    .font {
      position: absolute;
      right: 0;
      bottom: 0;
      height: 22px;
      line-height: 18px;
      background: #999;
      margin-bottom: 0;
      padding: 3px 6px;
      border-radius: 4px;

      span {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}

.activityContainer >>> .el-radio__label {
  font-size: 0.18rem;
  font-family: initial;
  color: #999;
}

.activityContainer >>> .el-radio__inner {
  border: 2px solid #dcdfe6;
  width: 16px;
  height: 16px;
}

.activityContainer >>> .el-checkbox__label {
  font-size: 0.18rem;
  font-family: initial;
  color: #999;
}

.activityContainer >>> .el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.activityContainer >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 3.6rem;
  height: 2rem;
  margin-top: 0.1rem;
}

.activityContainer >>> .el-button--small, .el-button--small.is-round {
  display: block;
  margin: 0.4rem 0 0.2rem 1rem;
  border-radius: 1rem;
  background: #0060ff;
  width: 1.6rem;
  line-height: 0.34rem;
  font-size: 0.21rem;
}

.activityContainer >>> .el-input__inner {
  width: 100%;
  height: 40px;
  margin-top: 0;
}

.activityContainer {
  background: #fff;
  width: 19.5rem;
  margin: 0.5rem auto;
  padding: 0.62rem 3.7rem;
  padding: 0.62rem 100px 2rem;
  box-sizing: border-box;
}

// .uploadContainer {
// padding: 0.62rem 100px 2rem;
// }
.newActivityLunch {
  .contact {
    color: #000;
    font-size: 0.18rem;
    letter-spacing: 1px;
    line-height: 0.35rem;
    font-family: initial;

    p {
      margin-bottom: 0.24rem;
    }
  }

  .el-form-item {
    color: #000;

    .el-radio {
      color: #777;
      line-height: 3;
      margin-right: 30px;
    }

    .el-radio + .el-radio {
      margin-left: 0;
    }

    .el-checkbox {
      width: 1.5rem;
      margin-right: 30px;
    }

    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }

    .dateLine {
      text-align: center;
    }
  }

  .button-wrap {
    display: flex;
    // justify-content: space-between;
    padding-bottom: 0.4rem;
    align-items: center;
    justify-content: center;

    .button {
      width: 2.5rem;
      height: 0.64rem;
      // line-height: 0.68rem;
      text-align: center;
      border-radius: 0.9rem;
      font-size: 0.24rem;
    }

    .confirm {
      background-color: #0060ff;
      color: #ffffff;
    }

    .keep {
      background: #3C5BB9;
    }

    .cancle {
      background-color: #eee;
      color: #999999;
    }
  }

  .font {
    font-size: 0.24rem;
    color: #000;
    margin-bottom: 0.2rem;
    display: inline-block;

    &.required::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .bline {
    width: 100%;
    height: 0.01rem;
    // background: #dcdfe6;
    margin: 0.2rem 0 0.2rem;
  }

  .editorContent {
    margin-top: 0.4rem;
  }

  .ActivityLunch {
    position: absolute;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0.7;
  }

  .thumb {
    // width: 3.8rem;
    // height: 2.1rem;
    width: 100%;
    height: 100%;
  }

  .thumb-uploader-icon, .cover-uploader-icon {
    display: block;
    width: 3.8rem;
    height: 2.1rem;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    position: relative;
    background: url('/static/explore/add.png') no-repeat center center #fff;
    -webkit-background-size: 0.8rem 0.8rem;
    background-size: 0.8rem 0.8rem;
    font-size: 0.22rem;
    color: #333333;
    text-align: center;
    // padding-top: 2.2rem;
    padding-top: 0.9rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #fdfdfd;
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
  }
}

.el-form-item >>> .el-upload--picture-card {
  line-height: 1.8rem;
  border: none;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(180deg);
  }
}

@keyframes rotate-reverse {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(0);
  }
}

.el-picker-panel__link-btn {
  display: none;
}
</style>
<style lang="stylus">
.newActivityLunch {
  .ticket-dialog {
    &>div {
      width: 800px !important;
    }

    .body {
      padding-right: 20px;

      .el-form-item__content {
        .el-input {
          width: 80%;
        }

        .number {
          width: 220px;
        }

        .el-textarea {
          .el-textarea__inner {
            height: 100px;
          }
        }
      }
    }
  }

  .block {
    display: block !important;
  }

  .primary.el-button--primary {
    display: block;
    margin: 20px auto;
  }

  .titleLen {
    position: absolute;
    right: 10px;
    top: 0;
  }

  .el-checkbox-button {
    // padding-bottom: 10px;
    font-size: 14px;

    .el-checkbox-button__inner {
      border: 1px solid #CCD0D7;
      border-radius: 20px;
      overflow: hidden;
      padding: 6px 16px;
      color: #999;
    }

    &.is-checked {
      .el-checkbox-button__inner {
        border-color: #446EEB;
        background-color: unset;
        color: #446EEB;
      }
    }
  }

  .el-radio-button .el-radio-button__inner {
    border: 1px solid rgb(165, 170, 179);
    border-radius: 20px;
    overflow: hidden;
  }

  .el-radio-button.is-active .el-radio-button__inner {
    border: 1px solid #409eff;
  }

  .thumb-uploader, .el-upload-list__item, .el-upload-list__item-thumbnail {
    height: auto;
  }

  .activityContainer {
    .tinymce {
      display: flex;

      .font {
        width: 140px;
        font-size: 16px;
        color: #000;
      }
    }

    .el-form-item {
      display: flex;

      .el-form-item__label {
        width: 140px;
        font-size: 16px;
        color: #000;
        word-wrap:break-word;
      }

      .el-form-item__content {
        flex: 1;
        height: auto !important;

        .el-col-11 {
          margin-left: 10px;
        }

        .limit {
          font-size: 12px;
          color: #999;
        }

        .el-checkbox-group, .el-radio-group {
          margin-bottom: 0;
          font-size: unset;

          label {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .activityContainer .el-form-item__content > div {
    margin-bottom: 10px;
  }

  .activityContainer .el-form-item__content > div .nickname {
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    text-align: left;
    vertical-align: middle;
  }

  .buyTicks span {
    display: block;
    font-size: 0.24rem;
    color: #000;
  }

  .buyTicks input {
    width: 45.83333%;
    height: 40px;
    border-radius: 4px;
    padding: 0 15px;
    margin-top: 15px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    background-color: #fff;
  }

  .buyTicks input::-webkit-input-placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }

  .buyTicks input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #c0c4cc;
    font-size: 14px;
  }

  .buyTicks input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #c0c4cc;
    font-size: 14px;
  }

  .buyTicks input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #c0c4cc;
    font-size: 14px;
  }
}

.activity-message {
  width: 400px;
}

.el-picker-panel__link-btn.el-button--text {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/pages/activity/newActivityLunch.vue